import { render, staticRenderFns } from "./contactVerification.vue?vue&type=template&id=5967a2d2&"
import script from "./contactVerification.vue?vue&type=script&lang=js&"
export * from "./contactVerification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports